export const fileExtensionRegex = /\.[^.]+$/;
export const htmlRegex = /<[^>]*>/g;
